export const ROUTES = {
    auth: {
        login: () => '/login',
        register: () => '/register',
    },
    home: () => '/',
    dashboard: () => '/dashboard',
    pricing: () => '/pricing',
    account: () => '/account',
    confirmEmail: () => '/confirm-email',
    billing: () => '/billing',
    privacy: () => '/privacy',
    terms: () => '/terms',
    docs: () => 'https://docs.mockd.sh',
    invite: (token: string) => `/invite/${token}`,
    teams: {
        dashboard: (teamId: string) => `/teams/${teamId}`,
        settings: (teamId: string) => `/teams/${teamId}/settings`,
    },
};